<template>
    <component :is="tagName" :class="classes">
        <slot />
    </component>
</template>
<script src="./kl-ol-map-tools-bar.ts"></script>
